import { Theme } from '@material-ui/core';
const styles = (theme: Theme) =>
  ({
    title: {
      '& h2': {
        paddingTop: 16,
        paddingBottom: 16,
      }
    },
    container: {
      display: 'flex',
      alignItems: 'flex-start',
      '& > div, & > form': {
        flex: 1,
      },
    },
    illu: {
      maxWidth: 400,
    },
    btnActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 16,
    },
    errorContainer: {
      marginTop: 12,
    },
    infoContainer: {
      marginTop: 12,
      '& > p': {
        maxWidth: 458,
      },
    },
    '@media all and (max-width: 430px)': {},
  } as any);

export default styles;
